import React, { useMemo, useState } from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import type { RediscoveryProps } from 'talent_matching/types';
import {
  RediscoveryPageContent,
  buildDefaultValues,
} from 'talent_matching/talent_rediscovery/rediscovery_page_content';
import Api from 'talent_search/lib/api';
import type { Paths, SavedSearchItem } from 'talent_search/shared/types';
import noop from 'lodash/noop';

const TalentRediscovery = (rediscoveryProps: RediscoveryProps) => {
  const [filteredCount, setFilteredCount] = useState(
    rediscoveryProps?.unfilteredCount ?? 0
  );
  const [loading, setLoading] = useState(false);
  const [savedFilterSet, setSavedFilterSet] = useState<SavedSearchItem | null>(
    null
  );

  const apiClient = useMemo(() => {
    if (!rediscoveryProps?.paths) {
      return null;
    }
    return new Api(rediscoveryProps.paths as unknown as Paths);
  }, [rediscoveryProps?.paths]);

  const defaultValues = useMemo(
    () =>
      rediscoveryProps
        ? buildDefaultValues(rediscoveryProps.userDateFormat)
        : buildDefaultValues(''),
    [rediscoveryProps]
  );

  if (!rediscoveryProps) {
    return (
      <Stack spacing={2}>
        <Body>{'Talent Rediscovery is not available.'}</Body>
      </Stack>
    );
  }

  return (
    <Form defaultValues={defaultValues} onSubmit={noop} submitMode="preserve">
      {apiClient && (
        <RediscoveryPageContent
          rediscoveryProps={rediscoveryProps}
          apiClient={apiClient}
          defaultValues={defaultValues}
          filteredCount={filteredCount}
          setFilteredCount={setFilteredCount}
          loading={loading}
          setLoading={setLoading}
          savedFilterSet={savedFilterSet}
          setSavedFilterSet={setSavedFilterSet}
        />
      )}
    </Form>
  );
};

export default TalentRediscovery;
